import { Component } from 'react'
import PropTypes from 'prop-types'

class InjectTracker extends Component {
  constructor (props) {
    super(props)

    this.trackerElement = null
  }

  static propTypes = {
    trackerScript: PropTypes.string.isRequired,
    trackerId: PropTypes.string
  }

  componentDidMount () {
    this.insertScript()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.trackerId !== this.props.trackerScript) {
      this.removeScript()
      this.insertScript()
    }
  }

  componentWillUnmount () {
    this.removeScript()
  }

  insertScript = () => {
    let trackerScript = this.props.trackerScript
    if (trackerScript && trackerScript.indexOf('<script') >= 0) {
      const range = document.createRange()
      range.setStart(document.body, 0)
      trackerScript = trackerScript.replace(/<script/g, '<script data-tag="analytics-tracker"')
      const documentFragment = range.createContextualFragment(trackerScript)

      document.body.appendChild(documentFragment)
      this.trackerElement = true
    }
  }

  removeScript = () => {
    if (this.trackerElement) {
      while (document
        .querySelector('script[data-tag="analytics-tracker"]')) {
        document.body.removeChild(document
          .querySelector('script[data-tag="analytics-tracker"]'))
      }
      this.trackerElement = false
    }
  }

  render () {
    return null
  }
}

export default InjectTracker
